import React, { useContext } from 'react';
import ColorsContext from './ColorsContext';

export default function UsgsTable(props) {
  const { regionData, monyr, sfgw, areaType } = props;
  const { levelColors } = useContext(ColorsContext);

  const sitetype = sfgw === 'gw' ? "well" : "gage";
  const sfgwTitle = sfgw === 'gw' ? "Groundwater" : "Streamflow";
  const sfgwPeriod = sfgw === 'gw' ? "" : "30-Day";
  
  let droughtRegions = [
    "Western",
    "Connecticut River",
    "Central",
    "Northeast",
    "Southeast",
  ];

  if (regionData['Cape Cod']) {
    droughtRegions.push("Cape Cod");
  };
  if (regionData['Islands']) {
    droughtRegions.push("Islands");
  };

  const basins = [
    "Blackstone",
    "Boston Harbor",
    "Buzzards Bay",
    "Cape Cod",
    "Charles",
    "Chicopee",
    "Connecticut",
    "Deerfield",
    "Farmington",
    "French",
    "Housatonic",
    "Hudson",
    "Ipswich",
    "Islands",
    "Merrimack",
    "Millers",
    "Narragansett Bay",
    "Nashua",
    "North Coastal",
    "Parker",
    "Quinebaug",
    "Shawsheen",
    "South Coastal",
    "SuAsCo",
    "Taunton",
    "Ten Mile",
    "Westfield"
  ];

  const droughtAreas = areaType === 'region' ? droughtRegions : basins;

  return (
    <>
    <table className="pcpnTable-container">
      <caption>
        {monyr} {monyr.search(",") < 0 ? "Monthly" : sfgwPeriod} {sfgwTitle} Summary
      </caption>
      <thead>
        <tr>
            <td colSpan="3">
                <table className="tableLegend-container">
                    <tbody>
                        <tr>
                            <td className="tableLegend-heading" colSpan="5">Shading indicates index severity level:</td>
                        </tr>
                        <tr>
                            <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[0]}}>Level 0</td>
                            <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[1]}}>Level 1</td>
                            <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[2]}}>Level 2</td>
                            <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[3]}}>Level 3</td>
                            <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[4], "color":"white"}}>Level 4</td>
                        </tr>
                    </tbody>
                </table>
            </td>
        </tr>
        <tr>
          <th scope="col">{areaType[0].toUpperCase() + areaType.slice(1)}</th>
          <th scope="col">{"Number of " + sitetype + "s reporting"}</th>
          <th scope="col" abbr="Median">{"Median of individual " + sitetype + " percentiles"}</th>
         </tr>
      </thead>
      <tbody>
        {droughtAreas.map((rd, i) => (
          <tr key={i}>
            <th scope="row">{rd.replace("Connecticut River","CTRV")}</th>
            <td>{regionData[rd].count}</td>
            <td 
              style={{
                backgroundColor: levelColors[regionData[rd].level], 
                color: regionData[rd].level !== 4 ? "black" : "white"
              }}
            >
              {regionData[rd].median !== -999 ? regionData[rd].median : '-'}
            </td>
          </tr>
        ))}
      </tbody>
    </table>

    <table className="pcpnTable-container">
      <caption>
        {"Number of " + sitetype + "s in percentile categories"}
      </caption> 
      <thead>
        <tr>
          <th scope="col">{areaType[0].toUpperCase() + areaType.slice(1)}</th>
          <th scope="col">&ge;0 to &le;2</th>
          <th scope="col">&gt;2 to &le;10</th>
          <th scope="col">&gt;10 to &le;20</th>
          <th scope="col">&gt;20 to &le;30</th>
          <th scope="col">&gt;30 to &le;90</th>
          <th scope="col" className="padHead">&gt;90</th>
        </tr>
      </thead>     
      <tbody>
        {droughtAreas.map((rd, i) => (
          <tr key={i}>
            <th scope="row">{rd.replace("Connecticut River","CTRV")}</th>
            {regionData[rd].histogram.map((p, j) => (
              <td key={"hist"+i+j}>{regionData[rd].count > 0 ? p : '-'}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
    </>
  );
}